<div id="feedback" class="feedback-container ya-typography" (swiperight) = "SwiperNavigateBack()" >
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="true">
    <h2 class="ya-header-title" langkey="phFeedback_Title"></h2>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
    <div class="content-message">
      <span>{{setFeedBackMessage()}}</span>
    </div>
    <div class="ya-button-group-wrapper">
      <div class="ya-button-group-container">
        <ng-container *ngIf="isMobile; then appRouteTemplate else browserRouteTemplate"></ng-container>
        <ng-template #browserRouteTemplate>
          <div class="ya-webshop-button-container">
          <button mat-flat-button (click)="openRateModel()">
            <span><span langkey="phFeedback_Button_Rate"></span></span>
          </button>
        </div>
        </ng-template>
        <ng-template #appRouteTemplate>
          <div class="ya-webshop-button-container">
            <button mat-flat-button (click)="routeToAppVoting()">
              <span><span langkey="phFeedback_Button_Rate"></span></span>
            </button>
          </div>
        </ng-template>
        <div class="ya-webshop-button-container">
          <button mat-flat-button (click)="openRateModel()">
            <span><span langkey="phFeedback_Button_Feedback"></span></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>